var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrowReset = function SvgDoubleArrowReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.35,
    d: "M4.105 12.35c0-5.143 3.74-8.415 7.948-8.415 2.805 0 5.608 1.494 7.012 3.74m0 0H14.39m4.675 0V3M20 11.415c0 5.142-3.74 8.415-7.947 8.415-2.805 0-5.609-1.494-7.013-3.74m0 0h4.675m-4.675 0v4.675",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgDoubleArrowReset;